// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"482":"1fd66da4a180a4b2","551":"557acc2669d9f57e"}[chunkId] + ".js";
};